var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.75 13.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_2",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Laag_1",
    "data-name": "Laag 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M5.25,13.3,9.59,9a.53.53,0,0,0,0-.75l-.32-.32a.51.51,0,0,0-.73,0l0,0-3,3V.34A.35.35,0,0,0,5.19,0H4.55a.34.34,0,0,0-.34.34h0V10.87l-3-3a.54.54,0,0,0-.76,0L.15,8.2A.54.54,0,0,0,.15,9L4.49,13.3A.56.56,0,0,0,5.25,13.3Z",
    transform: "translate(0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.780850da3e0460ebc361de73c39a493d.svg";
export { ForwardRef as ReactComponent };